import { useMemo } from 'react';

import { ITranslateMethod } from '@core/js/hooks/i18n/types';
import { fn, required } from '@core/js/utils/Validation/validationRules';

import { useFundsTransferSelector } from '@interlayer/js/app/store/hooks/useFundsTransferSelector';

export const useCheckFoundTransferAmount = (t: ITranslateMethod) => {
    const { fundsTransferConfig: { allowedToTransfer } } = useFundsTransferSelector();

    return useMemo(() => [
        required({ error: t('amount.required') }),
        fn({
            fn: (value: string) => {
                const data = Number(value);

                if (isNaN(data) || data > Number(allowedToTransfer.value)) {
                    return [t('amount.limits', [allowedToTransfer.label])];
                }
            }
        })
    ], [allowedToTransfer.label, allowedToTransfer.value, t]);
};
